export default __webpack_public_path__ + "5efa4a3ab430be7b3a3b2adef6d7b052.png";